<template>
    <div class="cz3__image-gallery-small">
        <progress-bar />

        <form-fields class="cz3__flex-1">
            <div class="cz3__image-gallery__list">
                <gallery-list
                    :max-items="7"
                    @uploading="uploading"
                />
            </div>

            <step-buttons>
                <secondary-button
                    class="cz3__flex-1"
                    :label="$t('V3_BACK')"
                    @click="back"
                />

                <action-button
                    class="cz3__flex-1"
                    :label="$t('V3_NEXT')"
                    :disabled="editComponent == null || uploadWorking"
                    @click="next"
                />
            </step-buttons>
        </form-fields>
    </div>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz3__image-gallery-small {
            position: absolute;

            left: 0;
            top: 0;

            width: 100%;
            height: 100%;

            display: flex;
            flex-direction: column;

            gap: 24px;

            z-index: 10000;

            background: #fff;
        }

        .cz3__image-gallery__list {
            flex: 1 1 0;

            // Unmargin it on small screens.
            margin-left: -16px;
            margin-right: -16px;

            padding-left: 16px;
            padding-right: 16px;

            overflow: auto;
            -webkit-overflow-scrolling: touch;
        }
    }
</style>

<script>
    import ProgressBar from './ProgressBar.vue';
    import FormFields from './FormFields.vue';
    import ActionButton from './ActionButton.vue';
    import SecondaryButton from './SecondaryButton.vue';
    import StepButtons from './StepButtons.vue';
    import GalleryList from './GalleryList.vue';

    export default {
        components: {
            ProgressBar,
            FormFields,
            ActionButton,
            SecondaryButton,
            StepButtons,
            GalleryList,
        },

        data() {
            return {
                uploadWorking: false,
            };
        },

        computed: {
            viewController() {
                return this.$store.state.customizer.viewController;
            },

            editPlacements() {
                return this.$store.state.customizer.editPlacements;
            },

            editPlacement() {
                if (this.editPlacements && this.editPlacements.length > 0) {
                    return this.editPlacements[0];
                }

                return null;
            },

            editComponent() {
                if (this.editPlacement) {
                    return this.viewController.selectedAtPlacement(this.editPlacement.code);
                }

                return null;
            },

            personalizationMethod() {
                return this.$store.state.customizer.personalizationMethod;
            },
        },

        mounted() {
        },

        methods: {
            back() {
                this.$store.dispatch('showImageGalleryV3', false);
                this.$store.dispatch('setSelectedSubStepV3', 'choose');
            },

            next() {
                this.$store.dispatch('showImageGalleryV3', false);

                if (this.editComponent.custom['allow-colors'] === 'true') {
                    if (this.personalizationMethod !== 'etching') {
                        this.$store.dispatch('setSelectedSubStepV3', 'gallery-color');
                    } else {
                        this.$store.dispatch('setSelectedSubStepV3', 'gallery-alignment');
                    }
                } else {
                    this.$store.dispatch('setSelectedSubStepV3', 'gallery-alignment');
                }
            },

            uploading(v) {
                this.uploadWorking = v;
            },
        },
    };
</script>
